import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import QuoteCart from "../../components/QuoteCart/QuoteCart";
import QuoteForm from "../../components/QuoteForm/QuoteForm";
import QuoteSidebar from "../../components/QuoteSidebar/QuoteSidebar";
import SectionTitle from "../../components/ui/SectionTitle";

export default function Quote() {
  return (
    <section className="container-pad py-12">
      <Breadcrumb items={[{ label: "Request Quote" }]} />
      <SectionTitle eyebrow="Quote request" title="Prepare your EV product enquiry" description="Review selected cells, BMS, chargers, machines or accessories, add notes and submit your requirement. The sales team will send the quotation manually." />
      <div className="grid gap-8 lg:grid-cols-[1fr_340px]">
        <div className="grid gap-8">
          <QuoteCart />
          <QuoteForm />
        </div>
        <div className="hidden lg:block">
          <QuoteSidebar />
        </div>
      </div>
    </section>
  );
}
